
  <section class="cmn-innerpage-wrapper branch">
    <div class="head">
      <div class="search-wrapper" >
        <input
          type="text"
          class="cmn-header-search"
          placeholder="Search"
          (input)="onSearch($event)"
        />
      </div>
      <div class="right-set" *ngIf="canCreateBranch$ | async">
        <button class="cmn-add-btn" (click)="openDialog()">
          <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add
          Branch
        </button>
      </div>
    </div>
    <div class="inner-content" *ngIf="canListBranch$ | async">
      <ag-grid-angular
        style="width: 100%"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [rowSelection]="rowSelection"
        [suppressRowClickSelection]="true"
        [pagination]="true"
        [paginationPageSize]="paginationPageSize"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        [class]="themeClass"
      />
    </div>
  </section>

